import React from 'react';
import Arrow from '@/components/Arrow';
import styles from './index.module.scss';

export interface NewsCardProps {
  title: React.ReactNode;
  summary: string;
  cover: string;
  mediaLogo?: string;
  href?: string;
}

export default function NewsCard({ title, summary, cover, mediaLogo, href }: NewsCardProps) {
  const content = (
    <>
      <div className={styles.coverWrap}>
        <img src={cover} alt="" loading="lazy" />
      </div>
      <div className={styles.body}>
        <div className={styles.copy}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.summary}>{summary}</p>
        </div>
        <div className={styles.meta}>
          {mediaLogo ? <img className={styles.logo} src={mediaLogo} alt="" loading="lazy" /> : <span />}
          <Arrow className={styles.arrow} color="#86909c" aria-hidden />
        </div>
      </div>
    </>
  );

  if (href) {
    return (
      <a className={styles.card} href={href} target="_blank" rel="noreferrer">
        {content}
      </a>
    );
  }

  return <article className={styles.card}>{content}</article>;
}
